export const tools = [
    {
        name: 'audit_Audit_list',
        description: "The caller's tenant's audit log, newest first; `since` / `until` bound it by time.",
        context: 'audit',
        operationId: 'Audit_list',
        method: 'GET',
        path: '/audit',
        action: 'audit:list',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {
                query: {
                    type: 'object',
                    properties: {
                        cursor: {
                            type: 'string',
                        },
                        limit: {
                            type: 'integer',
                            format: 'int32',
                            minimum: 1,
                            maximum: 200,
                            default: 50,
                        },
                        since: {
                            type: 'string',
                            format: 'date-time',
                        },
                        until: {
                            type: 'string',
                            format: 'date-time',
                        },
                        action: {
                            type: 'string',
                        },
                        resourceKind: {
                            type: 'string',
                        },
                    },
                    required: [],
                    additionalProperties: false,
                },
            },
            required: [],
            additionalProperties: false,
        },
    },
];
//# sourceMappingURL=tools.js.map